import { LISTA_LOTES_POR_PASTO } from "../../../redux/actions/actionsConstants";

/**
 * @deprecated in favor of typescript actions (not yet migrated)
 * - when `listaLotesPasto` operation is migrated, remove this class too
 */
export const listarLotesPorPasto = (lotes) => {
  return {
    type: LISTA_LOTES_POR_PASTO,
    payload: { LotesPorPasto: lotes },
  };
};
